import React, { useState } from "react";
import "./../../components/style/Connexion.css";
import Inscription from "./Inscription";
import Home from "../home/Home";
import DialogBox from "../util/DialogBox";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAuth from "../../hooks/useAuth";

function Connexion() {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [showInscription, setShowInscription] = useState(false);
  const [showHub, setShowHub] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { user, login: serverLogin, logout } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const LOGO_CONNEXION_IMG = "/rm_imgs/logo_connexion.png";

  /**
   * Connexion via la session serveur (POST /auth/login).
   * L'identité est portée par le cookie httpOnly ; aucun hash de mot de
   * passe ne transite ni n'est comparé dans le navigateur.
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await serverLogin(login, password);
    if (result.ok) {
      setShowHub(true);
    } else {
      DialogBox({
        text: t(result.status === 429 ? "authTooManyAttempts" : "connexionError"),
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  if (showHub && user) {
    // Le DTO serveur expose `id` ; les écrans métier historiques utilisent
    // `_id`. On aligne sans re-stocker de document côté client.
    return <Home userData={{ ...user, _id: user.id, id: user.id }} setUserData={() => {}} logout={logout} />;
  }
  if (showInscription === true) {
    return <Inscription />;
  } else {
    return (
      <div className="App">
        <div className="AppContainer d-flex flex-column align-items-center justify-content-center">
          <form
            className="accessPageConnexion d-flex flex-column align-items-center justify-content-center"
            onSubmit={(e) => {
              handleSubmit(e);
            }}
          >
            {/* <h2 className="mb-5">{t("connexion")}</h2> */}
            <img
              src={LOGO_CONNEXION_IMG}
              alt="Logo RoadMaker"
              className="logoConnexion"
            />

            <div className="mt-3 d-flex flex-column align-items-center justify-content-center">
              <h6 className="labelConnexion">{t("username")}</h6>
              <input
                type="text"
                value={login}
                className="inputConnexion"
                required
                onChange={(e) => {
                  setLogin(e.target.value);
                }}
                aria-label="Identifiant"
              />
              <h6 className="labelConnexion mt-3">{t("password")}</h6>
              <div className="d-flex">
                <input
                  type={showPassword ? "text" : "password"}
                  className="inputPassword "
                  value={password}
                  required
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  aria-label="Mot de passe"
                />
                <button
                  className="buttonShowPassword"
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <i className="bi bi-eye-slash"></i>
                  ) : (
                    <i className="bi bi-eye"></i>
                  )}
                </button>
              </div>
            </div>
            <div className="buttonsContainerConnexion d-flex align-items-center justify-content-center">
              {" "}
              <input
                type="submit"
                value={t("logIn")}
                className="btnConnexion me-3"
                onClick={(e) => {
                  handleSubmit(e);
                }}
                aria-label="connexion-form"
              />
              <input
                type="submit"
                value={t("notRegistred")}
                className="btnConnexion"
                onClick={() => {
                  setShowInscription(true);
                }}
              />
            </div>
            <div className="buttonsInscription d-flex flex-column align-items-center justify-content-center">
              <input
                type="submit"
                value={t("forgotPassword")}
                className="btnMdpOublie mt-4 mb-2"
                onClick={() => navigate("/ForgottenPassword")}
              />
              <input
                type="submit"
                value={t("backToHub")}
                className="btnBack"
                onClick={() => {
                  // C4 (2026-09-04) : retour à la racine ; Root y affiche le
                  // hub ou la connexion selon la session. L'ancien rendu de
                  // PaletteMaker hors contexte projet produisait une page
                  // blanche.
                  navigate("/");
                }}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default Connexion;
